<div class="travel-loader-cont {{classType}}">
  <div class="img-cont">
    <ng-lottie
      width="widthAnimation"
      height="heightAnimation"
      [options]="options"
      [styles]="styles">
    </ng-lottie>
  </div>
</div>
